import type { PublicationCode } from '@/scopes/common/domain/models'

const BOOKING_URLS: Partial<Record<PublicationCode, string>> = {
  SZ: '/mijn-sunweb/boeking',
  FZ: '/mon-sunweb/booking',
  KZ: '/mit-sunweb/booking',
  FS: '/fr/mon-sunweb/booking',
  BZ: '/nl/mijn-sunweb/boeking',
}

export function getBookingPageUrl(publicationCode: PublicationCode): string | null {
  return BOOKING_URLS[publicationCode] ?? null
}
